import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import { getDefaultDashboardPath, resolvePrimaryRole } from '../../utils/rolePriority';
import { Loader2 } from 'lucide-react';

const RoleBasedRedirect = () => {
  const { user, isLoading } = useContext(AuthContext);

  if (isLoading) {
    return (
      <div className="flex h-[100dvh] w-full items-center justify-center">
        <Loader2 className="h-12 w-12 animate-spin text-blue-600" />
        <span className="ml-4 text-ds-body text-slate-700">Loading...</span>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/" replace />;
  }

  const primary = resolvePrimaryRole(user);
  const target = getDefaultDashboardPath(primary);
  return <Navigate to={target} replace />;
};

export default RoleBasedRedirect;
